import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const ResourceByRegion = ({ resources = [] }) => {
  const [chartData, setChartData] = useState({
    series: [{ name: 'Resources', data: [] }],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: { show: true },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          borderRadius: 5,
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: [],
        title: {
          text: 'Regions',
          style: { fontSize: '14px', fontWeight: 'bold' },
        },
      },
      yaxis: {
        title: {
          text: 'Resource Count',
          style: { fontSize: '14px', fontWeight: 'bold' },
        },
      },
      colors: ['#00E396'],
      legend: { position: 'bottom' },
    },
  });

  useEffect(() => {
    if (resources && Array.isArray(resources) && resources.length > 0) {
      const regionCounts = {};
      
      resources.forEach(resource => {
        const region = resource.region || 'Unknown';
        regionCounts[region] = (regionCounts[region] || 0) + 1;
      });

      const sortedRegions = Object.entries(regionCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10);

      const categories = sortedRegions.map(([region]) => region);
      const data = sortedRegions.map(([, count]) => count);

      setChartData(prev => ({
        ...prev,
        options: {
          ...prev.options,
          xaxis: { ...prev.options.xaxis, categories },
        },
        series: [{ name: 'Resources', data }],
      }));
    } else {
      setChartData(prev => ({
        ...prev,
        options: {
          ...prev.options,
          xaxis: { ...prev.options.xaxis, categories: ['No Data'] },
        },
        series: [{ name: 'Resources', data: [0] }],
      }));
    }
  }, [resources]);

  return (
    <div className="rounded shadow p-3 pb-0">
      <h5 className="fw-bold text-muted mb-3" style={{ color: '#333' }}>
        Resources by Region
      </h5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height="350"
      />
    </div>
  );
};

export default ResourceByRegion;
